import "../Errors.scss";
import FloatingMessageLayout from "../../layouts/FloatingMessageLayout";
import LogoHeaderCard from "../../cards/LogoHeaderCard";
import Translate from "lang/Translate";

const AuthError = () => (
    <FloatingMessageLayout>
        <LogoHeaderCard loading={false}>
            <div data-testid="auth-error" className="error_center_content" key="logoutcontent">
                <Translate text="auth_error" />
            </div>
        </LogoHeaderCard>
    </FloatingMessageLayout>
);
export default AuthError;
